// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1nP7B","dragIcon":"SortableItem_dragIcon__1Hbqj","disabled":"SortableItem_disabled__3ZE50"};